import Err from '../../models/err';

export default function createInvalidCompanyNumberError(companyNumber) {
  return new Err({
    code: Err.Code.INVALID,
    attr: 'companyNumber',
    detail: `Phone number "${companyNumber}" is not configured to make calls`,
  });
}
